// Rótulo do fornecedor da linha do orçamento (Rafael 20/10): nome FANTASIA antes da razão social,
// que é como o operador procura. Só exibição — o `nome` gravado na linha não muda (os resumos por
// fornecedor agrupam por ele).

export const ROTULO_SEM_FORNECEDOR = 'Fornecedor não informado';
export const LIMITE_BUSCA_FORNECEDOR = 50;

const texto = (valor) => (valor === null || valor === undefined ? '' : String(valor).trim());

// O show do orçamento devolve `nome` = "codigo - razão - fantasia" (CONCAT do eager load); a busca e
// a seleção pelo modal guardam a razão pura em `razaosocial`. Devolve a razão nos dois casos.
export function razaoSocialFornecedor(fornecedor) {
    if (!fornecedor) return '';
    if (texto(fornecedor.razaosocial)) return texto(fornecedor.razaosocial);
    const nome = fornecedor.nome === null || fornecedor.nome === undefined ? '' : String(fornecedor.nome);
    if (Object.prototype.hasOwnProperty.call(fornecedor, 'codigo')) {
        const prefixo = `${fornecedor.codigo ?? ''} - `;
        const sufixo = ` - ${fornecedor.nomefantasia ?? ''}`;
        if (nome.length >= prefixo.length + sufixo.length && nome.startsWith(prefixo) && nome.endsWith(sufixo)) {
            return nome.slice(prefixo.length, nome.length - sufixo.length).trim();
        }
    }
    return nome.trim();
}

export function temFornecedor(fornecedor) {
    return !!fornecedor && (texto(fornecedor.id) !== '' || texto(fornecedor.nome) !== '');
}

// "2917 - FANTASIA — Razão Social"; sem fantasia (ou igual à razão), só a razão.
export function rotuloFornecedor(fornecedor) {
    if (!temFornecedor(fornecedor)) return ROTULO_SEM_FORNECEDOR;
    const razao = razaoSocialFornecedor(fornecedor);
    const fantasia = texto(fornecedor.nomefantasia);
    const codigo = texto(fornecedor.codigo);
    const nomes = fantasia && fantasia.toUpperCase() !== razao.toUpperCase()
        ? (razao ? `${fantasia} — ${razao}` : fantasia)
        : razao;
    if (!nomes) return codigo || ROTULO_SEM_FORNECEDOR;
    return codigo ? `${codigo} - ${nomes}` : nomes;
}

// Registro do /participante -> fornecedor da linha. `nome` segue a razão social, como antes do modal.
export function fornecedorDoRegistro(registro) {
    return {
        id: registro.id,
        nome: registro.nome,
        cnpj: registro.cnpj ?? null,
        codigo: registro.codigo ?? null,
        nomefantasia: registro.nomefantasia ?? null,
        razaosocial: registro.nome ?? null,
    };
}

export function documentoFornecedor(registro) {
    const cnpj = texto(registro?.cnpj).replace(/\D/g, '');
    if (cnpj.length === 14) return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    if (cnpj) return cnpj;
    const cpf = texto(registro?.cpf).replace(/\D/g, '');
    if (cpf.length === 11) return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    return cpf;
}

export function cidadeUfFornecedor(registro) {
    const municipio = registro?.enderecomunicipio;
    if (!municipio || typeof municipio !== 'object') return '';
    const nome = texto(municipio.nome);
    const uf = texto(municipio.uf);
    return nome && uf ? `${nome}/${uf}` : (nome || uf);
}

// Parâmetros da busca do modal: o filtro `nome` da API já casa razão (contém), código (exato), nome
// fantasia (contém) e CPF/CNPJ (só dígitos, contém).
export function parametrosBuscaFornecedor(termo) {
    const params = {
        tipoCadastro: ['orcamento', 'empresa'],
        situacaoRegistro: 'ativo',
        limit: LIMITE_BUSCA_FORNECEDOR,
        semHistorico: true,
        include: 'enderecomunicipio',
    };
    const t = texto(termo);
    if (t) params.nome = t;
    return params;
}
